import { postApi } from '../api/digitalVault';
import { repositoryOpts } from '../api/digitalVault';
export default async ({ name, type }, logger) => {
    const query = new URLSearchParams();
    query.append('name', name);
    !!type && query.append('type', type);
    return await postApi(query, 'repository', {
        ...repositoryOpts.headers,
    }, logger);
};
